// RetiredBadge — how a retired row says so, wherever it appears.
//
// One badge for every list, so a retired customer on All Customers and its
// retired instance on Fleet Costs read the same way. The date is the day the
// retirement was decided, as the row carries it; the reason rides on the
// title, where a reader who wants to know why can hover for it without the
// table growing a column for a sentence most rows leave empty.
//
// Secondary, not destructive: a retirement is a fact about a relationship
// that ended, not an error on the row.

import { Badge } from '@miq/design-system/components/ui/badge';

import { onDay } from '../data/instants';
import type { Retired } from '../data/reads';

export function RetiredBadge({ retired }: { retired: Retired }) {
  return (
    <Badge variant="secondary" title={`${retired.reason} — ${retired.by}`}>
      Retired {onDay(retired.at)}
    </Badge>
  );
}
